<style lang="scss">
.productionAllRowTable::before {
  z-index: inherit;
}

.productionAllRowTable.el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #33333a !important;
}

.productionAllRowTable.el-table {
  background-color: transparent;
}

.productionAllRowTable.el-table--border:after,
.productionAllRowTable.el-table--group:after,
.productionAllRowTable.el-table:before {
  background-color: transparent;
}

.productionAllRowTable.el-table tr {
  background-color: transparent;
}

.productionAllRowTable.el-table td.gutter,
.productionAllRowTable.el-table th.gutter {
  background: #33333a;
}

.productionAllRowTable .el-table__body-wrapper {
  background: #1d1d24;
}

// 滚动条的宽度
.productionAllRowTable .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

// 滚动条的滑块
.productionAllRowTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

.gridMode::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

.gridMode::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

// .productionAllRowTable .el-table__body-wrapper::-webkit-scrollbar-track {
// 	/*滚动条里面轨道*/
// 	border-radius: 2px;
// 	background: #1D1D24;
// }</style>

<style scoped></style>
<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
    <setting v-show="false"></setting>
    <div :style="{ height: contentHeight + 'px' }">
      <el-table ref="table" class="productionAllRowTable" :data="progresses" style="width: 100%" :max-height="contentHeight" :row-style="getRowStyle" :cell-style="{ padding: 0 + 'px', borderColor: '#202027', color: '#FFFFFF', 'font-size': '16px' }" :header-cell-style="{ background: '#33333A', color: '#E9E9EB', padding: '0px', height: '42px', borderColor: '#33333A', 'font-size': '14px' }">
        <template v-for="(col, index) in monitorSetting.MONITOR_PRODUCTION_SCHEDULE_CONFIG_COLUMNS">
          <el-table-column :sortable="true" v-if="col == 'shebeibianhao'" prop="equipment.name" :label="$t('shebeibianhao')"> </el-table-column>
          <el-table-column :sortable="true" v-else-if="col == 'shengchangongdanhao'" prop="wo.no" :label="$t('shengchangongdanhao')"> </el-table-column>
          <el-table-column :sortable="true" v-else-if="col == 'chanpinmingcheng'" prop="material.name" :label="$t('chanpinmingcheng')"> </el-table-column>
          <el-table-column v-else-if="col == 'banchanmo'" prop="shiftProduction" :label="$t('banchanmo')"> </el-table-column>
          <el-table-column v-else-if="col == 'banchanyongliao'" prop="shiftConsumption" :label="$t('banchanyongliao')"> </el-table-column>
          <el-table-column v-else-if="col == 'dingdanyongliao'" prop="orderConsumption" :label="$t('dingdanyongliao')"> </el-table-column>
          <el-table-column v-else-if="col == 'zongjihuashuliang'" prop="wo.planQuantity" :label="$t('zongjihuashuliang')"> </el-table-column>
          <el-table-column v-else-if="col == 'shengyumoshu'" prop="wo.leftProductionQuantity" :label="$t('shengyumoshu')"> </el-table-column>
          <el-table-column v-else-if="col == 'yishengchanshuliang'" prop="wo.finishGoodQuantity" :label="$t('yishengchanshuliang')"> </el-table-column>
          <el-table-column v-else-if="col == 'dingdanjiaofuriqi'" prop="orderDeliveryDate" :label="$t('dingdanjiaofuriqi')"> </el-table-column>
          <el-table-column v-else-if="col == 'zaobanrenyuan'" prop="firstShiftUser" :label="todayDate+'('+$t('zao')+')'"> </el-table-column>
          <el-table-column v-else-if="col == 'wanbanrenyuan'" prop="secondShiftUser" :label="todayDate+'('+$t('wan')+')'"> </el-table-column>
          <el-table-column v-else-if="col == 'daishengchandingdan'" prop="pendingWo" :label="$t('daishengchandingdan')"> </el-table-column>
          <el-table-column v-else-if="col == 'zhuyishixiangguanzhu'" prop="attention" :label="$t('zhuyishixiangguanzhu')"> </el-table-column>
          <el-table-column v-else-if="col == 'beizhu'" :label="$t('beizhu')" prop="remark"> </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script type="text/javascript">
import setting from '@@/pages/web/monitor/production_all/setting';
export default {
  name: 'web_monitor_production_all_row',
  components: {
    setting: setting
  },
  data() {
    return {
      monitorSetting: {},
      listSize: 0,
      interval: null,
      timer: null,
      contentHeight: 0,
      rowHeight: 0,
      progresses: [],
      isStopListScroll: false,
      isStopGridScroll: false,
      todayDate: '',
    };
  },
  created() {
    // 1. 立即执行首次查询
    this.listProductionScheduleConfig();
    this.todayDate = this.dayjs().format('MM.DD');
    // 2. 计算距离下一个“5分钟整数倍”时刻的剩余毫秒数
    let now = new Date();
    let currentMinutes = now.getMinutes();
    let currentSeconds = now.getSeconds();
    let currentMs = now.getMilliseconds();

    // 计算已经过去的毫秒数（在当前5分钟周期内）
    let passedInCycle = (currentMinutes % 5) * 60 * 1000 + currentSeconds * 1000 + currentMs;

    // 5分钟周期的总毫秒数
    let cycleMs = 5 * 60 * 1000;

    // 距离下一个周期开始的剩余时间
    let delay = cycleMs - passedInCycle;
    // 3. 使用 setTimeout 在第一个“整5分钟”时刻触发查询
    this.timer = setTimeout(() => {
      this.listProductionScheduleConfig();
      // 4. 开启固定的 5 分钟轮询
      this.timer = setInterval(() => {
        this.listProductionScheduleConfig();
      }, 300000);
    }, delay);
  },
  mounted() {
    this.resize();
    this.setScheduleConfigMonitor();
    this.utils.event_hub.$on('setScheduleConfigMonitor', () => {
      this.setScheduleConfigMonitor();
    });
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  destroyed() {
    this.utils.event_hub.$off('setScheduleConfigMonitor');
    if (this.timer) {
      clearTimeout(this.timer);
      clearInterval(this.timer);
    }
    if (this.interval) {
      clearInterval(this.interval);
    }
  },

  activated() {
  },
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listProductionScheduleConfig();
    },
  },
  computed: {
  },
  methods: {
    getRowStyle({ row, rowIndex }) {
      let baseStyle = {
        background: '#1D1D24',
        height: this.rowHeight + 'px'
      };
      return baseStyle;
    },
    setScheduleConfigMonitor() {
      let monitorSetting = localStorage.getItem('MONITOR_SETTING');
      if (!monitorSetting) {
        this.monitorSetting = {};
      } else {
        this.monitorSetting = JSON.parse(monitorSetting);
      }
    },
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const listDiv = this.$refs.table.bodyWrapper;
      const gridDiv = this.$refs.grids;
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
        if (!this.isStopGridScroll) {
          gridDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (gridDiv.clientHeight + gridDiv.scrollTop >= gridDiv.scrollHeight) {
            this.isStopGridScroll = true;
            setTimeout(() => {
              if (gridDiv.clientHeight + gridDiv.scrollTop >= gridDiv.scrollHeight) {
                gridDiv.scrollTop = 0;
              }
              this.isStopGridScroll = false;
            }, 5000);
          }
        }
        console.log(listDiv.clientHeight,listDiv.scrollTop,listDiv.scrollHeight)
        console.log(gridDiv.clientHeight,gridDiv.scrollTop,gridDiv.scrollHeight)
      }, 100);
    },

    async listProductionScheduleConfig() {
      let url = '/custom/jschicheng/production/schedule/config/listScheduleConfigToday';
      let response = await this.http.post(url, {
        params: {
          orgId: this.$attrs.orgId
        }
      });
      // 1. 获取原始数据，确保是数组
      let rawData = response.data || [];

      // 2. 数据处理
      let processedData = rawData.map(item => {
        // 保护嵌套对象，防止 prop="wo.no" 取值时报错
        if (!item.wo) {
          item.wo = {};
        }
        if (!item.material) {
          item.material = {};
        }
        if (item.orderDeliveryDate) {
          item.orderDeliveryDate = this.dayjs(item.orderDeliveryDate).format('YYYY-MM-DD');
        }
        Object.keys(item).forEach(key => {
          if (item[key] === null || item[key] === undefined) {
            item[key] = '';
          }
          if(item[key] === 0){
            item[key] = '0';
          }
        });
        return item;
      });

      // 3. 赋值处理后的数据
      this.progresses = processedData;
      console.log(processedData);

      this.todayDate = this.dayjs().format('MM.DD');
      this.listSize = this.progresses.length;
    },

    resize() {
      if (!this.$refs.container) {
        return;
      }
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        this.contentHeight = this.$refs.container.offsetHeight - 40;
        this.rowHeight = (this.contentHeight - 42 - 5) / 10;
      }, 800);
    },

  }
};
</script>
